'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.callIfPossible = callIfPossible;
exports.sequence = sequence;
exports.memoizedSequence = memoizedSequence;
exports.wrapRefObject = wrapRefObject;
exports.stackRefs = stackRefs;

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function callIfPossible(prop) {
  if (typeof prop !== 'function') {
    return prop;
  }

  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return prop.apply(undefined, args);
}

/**
 * Combines multiple event handlers into a single function.
 *
 * @example
 *  onClick={sequence(this.handleClick, onClick)}
 * @param  {...Function} handlers One or more event handlers to fire from the returned function
 * @returns {Function}
 */
function sequence() {
  for (var _len2 = arguments.length, handlers = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    handlers[_key2] = arguments[_key2];
  }

  return function () {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    handlers.forEach(function (handler) {
      return typeof handler === 'function' && handler.apply(undefined, args);
    });
  };
}

var sequenceCache = void 0;
var resultKey = {};

/**
 * Combines multiple event handlers into a single function. Unlike `sequence`, `memoizedSequence`
 * uses a cache to ensure that the same function instance is returned every time that you call it
 * with the same arguments, preventing unnecessary React updates.
 *
 * @example
 *  onClick={memoizedSequence(this.handleClick, onClick)}
 * @param  {...Function} handlers One or more event handlers to fire from the returned function
 * @returns {Function}
 */
function memoizedSequence() {
  for (var _len4 = arguments.length, handlers = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    handlers[_key4] = arguments[_key4];
  }

  var validHandlers = handlers.filter(function (handler) {
    return typeof handler === 'function';
  });
  if (validHandlers.length === 0) return undefined;
  if (validHandlers.length === 1) return validHandlers[0];

  // If this sequence has been generated before, return it
  var cache = sequenceCache;
  validHandlers.forEach(function (handler) {
    cache = cache && cache.get(handler);
  });
  if (cache instanceof WeakMap && cache.has(resultKey)) return cache.get(resultKey);

  // Otherwise, generate a new sequence and save it in the cache
  var newSequence = sequence.apply(undefined, _toConsumableArray(validHandlers));
  if (sequenceCache === undefined) sequenceCache = new WeakMap();

  cache = sequenceCache;
  validHandlers.forEach(function (handler) {
    if (!(cache.get(handler) instanceof WeakMap)) {
      cache.set(handler, new WeakMap());
    }
    cache = cache.get(handler);
  });
  cache.set(resultKey, newSequence);
  return newSequence;
}

var wrapRefObjectCache = void 0;

var makeCallbackForRefObject = function makeCallbackForRefObject(ref) {
  return function (el) {
    ref.current = el;
  };
};

/**
 * Returns a callback wrapper around the given ref object.
 * @param {Object} ref
 */
function wrapRefObject(ref) {
  if (ref == null) return ref;

  if (wrapRefObjectCache === undefined) wrapRefObjectCache = new WeakMap();
  if (wrapRefObjectCache.has(ref)) return wrapRefObjectCache.get(ref);
  var callback = makeCallbackForRefObject(ref);
  wrapRefObjectCache.set(ref, callback);
  return callback;
}

function stackRefs(componentName, originalRef) {
  var baseRef = originalRef;
  if (typeof originalRef === 'string') {
    _devLogger2.default.warn({
      message: componentName + ': Child ref is a string, which prevents additional refs. Please use a callback ref.',
      key: componentName + ': string ref'
    });
    return originalRef;
  }
  if ((typeof originalRef === 'undefined' ? 'undefined' : _typeof(originalRef)) === 'object') {
    // support createRefs (#6936)
    baseRef = wrapRefObject(originalRef);
  }

  for (var _len5 = arguments.length, extraRefs = Array(_len5 > 2 ? _len5 - 2 : 0), _key5 = 2; _key5 < _len5; _key5++) {
    extraRefs[_key5 - 2] = arguments[_key5];
  }

  return memoizedSequence.apply(undefined, extraRefs.concat([baseRef]));
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/core/Functions.js
// module id = 3
// module chunks = 171